"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MindMappingType = void 0;
/**
 * 思维导图类型
 */
var MindMappingType;
(function (MindMappingType) {
    MindMappingType[MindMappingType["LOGIC_DIAGRAM_LEFT"] = 0] = "LOGIC_DIAGRAM_LEFT";
    MindMappingType[MindMappingType["LOGIC_DIAGRAM_RIGHT"] = 1] = "LOGIC_DIAGRAM_RIGHT";
    MindMappingType[MindMappingType["MIND_MAPPING"] = 2] = "MIND_MAPPING";
    MindMappingType[MindMappingType["ORGANIZATION_STRUCTURE"] = 3] = "ORGANIZATION_STRUCTURE";
})(MindMappingType = exports.MindMappingType || (exports.MindMappingType = {}));
